import React from 'react'
import Svg from './Svg'
export const SvgQuestionMarkCircle = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm1.2 17.76h-2.64V15h2.64v2.76zm2.4-7.2c-.24.36-.48.72-.72.96s-.6.48-.84.6l-.72.72c-.24.24-.24.6-.24.84v.24h-2.52v-.36c0-.6.12-.96.24-1.44.12-.36.36-.72.72-.96.24-.24.48-.48.84-.6.24-.24.48-.36.72-.6.12-.12.24-.36.24-.72s-.12-.6-.36-.84-.48-.36-.96-.36-.84.12-1.08.36c-.24.48-.36.72-.36 1.2H8.04c0-1.08.36-1.92.96-2.64.72-.72 1.68-1.08 3-1.08 1.2 0 2.16.24 2.88.84.72.6 1.08 1.44 1.08 2.52 0 .48-.12.96-.36 1.32z" />
  </Svg>
))
SvgQuestionMarkCircle.isIcon = true
export default SvgQuestionMarkCircle
